import React, { useCallback } from 'react';
import _ from 'lodash'
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { DeviceEventEmitter } from "react-native";
import { AppRoutes } from "navigations/app-routes";
import HelperString from "utils/helper-string";
import i18n from "utils/i18n";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import { tabBarProps, tabBarScreenProps } from 'utils/helper-navigation'
import HelperPlatform from 'utils/helper-platform'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import { TESTID } from '_shared/config/testID'
import { navigationStyles } from 'navigations/_styles/styles'
import BottomTabBar from 'navigations/_components/BottomTabBar'
import HomeHomeIndexScene from 'scenes/home/home'
import HomeBookStartScene from 'scenes/home/book/start'
import HomeCoworkerIndexScene from 'scenes/home/coworker/index'
import HomeMoreIndexScene from 'scenes/home/more/index'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'
import { useIsSmallDevice } from 'utils/helper-device'

const Tab = createBottomTabNavigator();

export const useHomeTabs = () => {
	const _messageCount = useSelector( state => {
		return state.data[dataConstants.MESSAGE_COUNT];
	} );
	
	const tabs = [];
	
	// Add start
	tabs.push({
		name: AppRoutes.TAB_TODAY,
		testID: TESTID.HOME.NAVIGATION.HOME,
		title: i18n.t('navigation_tabbar.home'),
		icon: props => {
			return <TabIcon {...props} icon={IconSystemConstants.HOME} />;
		},
		component: HomeHomeIndexScene, //  keeps this like this
	});
	
	// Add create
	tabs.push({
		name: AppRoutes.TAB_BOOK,
		testID: TESTID.HOME.NAVIGATION.BOOK,
		title: i18n.t('navigation_tabbar.create'),
		icon: props => {
			return <TabIcon {...props} icon={IconSystemConstants.CALENDAR_PLUS} />;
		},
		component: HomeBookStartScene
	});
	
	// Add coworkers
	if( HelperSetting.isYes( settingsConstants.COWORKER_ENABLE_SCREEN ) ) {
		tabs.push({
			name: AppRoutes.TAB_COWORKERS,
			testID: TESTID.HOME.NAVIGATION.COWORKERS,
			title: i18n.t('navigation_tabbar.coworkers'),
			icon: props => {
				return <TabIcon {...props} icon={IconSystemConstants.PERSONS} />;
			},
			component: HomeCoworkerIndexScene
		});
	}
	
	// Add coworkers
	tabs.push({
		name: AppRoutes.TAB_MORE,
		testID: TESTID.HOME.NAVIGATION.MORE,
		title: i18n.t('navigation_tabbar.more'),
		icon: props => {
			return <TabIcon {...props} icon={IconSystemConstants.MORE} badge={_messageCount > 0 ? _messageCount : undefined} />;
		},
		component: HomeMoreIndexScene
	});

	return tabs;
}

const HomeTabsNavigator = () => {

	const isSmallDevice = useIsSmallDevice()
	const tabs = useHomeTabs();
	
	const onTabPress = useCallback( ( props, index ) => {
		const { navigation } = props;
		
		const routeName = tabs[ index ]?.name;
		
		//Trigger event
		DeviceEventEmitter.emit('routeStateChanged',  routeName );
		
		// Do the navigate
		// On web we have to reset
		if( HelperPlatform.isWeb() ) {
			navigation.reset( {
				index: 0,
				routes: [
					{
						name: routeName,
					}
				]
			} )
		} else {
			navigation.navigate( routeName );
		}
	}, [ tabs ] )
	
	return (
		<Tab.Navigator
			{ ...tabBarProps }
			screenOptions={{
				...tabBarProps.screenOptions,
				tabBarPosition: isSmallDevice ? 'bottom' : 'left',
			}}
			tabBar={ props => {
				return (
					<BottomTabBar
						props={ props }
						tabs={ tabs }
						vertical={ !isSmallDevice }
						onTabPress={ onTabPress }
					/>
				);
			} }>
			
			{ _.map( tabs, tab => {
				return (
					<Tab.Screen
						key={ HelperString.hash( 'HomeNavigator-TabNavigator', tab ) }
						{ ...tabBarScreenProps }
						name={ tab.name }
						component={ tab.component }
						options={{ title: tab.title }}
					/>
				);
			})}
		</Tab.Navigator>
	)
}

const TabIcon = ( props ) => {
	const tabIconStyle = [
		navigationStyles.bottomNavigationIcon,
		props.style
	]
	
	return (
		<Icon
			{ ...props }
			style={ tabIconStyle }
			size={ 24 }
			badgeStyle={ navigationStyles.bottomNavigationBadge }
		/>
	)
}

export default HomeTabsNavigator
